import React from 'react';
import PatientNavigationButtons, {
  getTreatmentFlowContextFromPatient,
} from './PatientNavigationButtons';

type PatientNavPage =
  | 'patient-edit'
  | 'consents'
  | 'treatment-reports'
  | 'patient-addresses'
  | 'long-term-frequents'
  | 'application-counts'
  | 'checkin-mails'
  | 'visits'
  | null;

interface PatientShape {
  id?: number | null;
  official?: boolean | null;
  serial_number?: string | number | null;
  visit_last_year_month?: string | null;
  visit_last_day?: string | null;
  patient?: { visit_last_day?: string | null } | null;
  current_patient_information?: { name?: string | null } | null;
}

interface PatientPageHeaderProps {
  /** Standard shape: renders `{serial_number}：{current_patient_information.name}`. */
  patient?: PatientShape | null;
  /** Use when the header text doesn't follow the standard serial:name pattern (overrides `patient`). */
  label?: React.ReactNode;
  patientId: string;
  tenant?: string;
  navigate: (path: string) => void;
  activeKey?: PatientNavPage;
  treatmentFlowContext?: { official: boolean; visitLastYearMonth: string };
  pdfTemplateMenu?: 'full' | 'compact';
  disabled?: boolean;
  /** Extra action buttons rendered next to the title (e.g. 新規作成 / 継続). */
  actions?: React.ReactNode;
}

const PatientPageHeader: React.FC<PatientPageHeaderProps> = ({
  patient,
  label,
  patientId,
  tenant,
  navigate,
  activeKey = null,
  treatmentFlowContext,
  pdfTemplateMenu,
  disabled,
  actions,
}) => {
  const displayLabel =
    label ?? `${patient?.serial_number ?? ''}：${patient?.current_patient_information?.name ?? ''}`;
  const resolvedTreatmentFlowContext =
    treatmentFlowContext ?? getTreatmentFlowContextFromPatient(patient);

  return (
    <div className="flex items-center justify-between mb-4 gap-8">
      <div className="flex flex-wrap items-center gap-4">
        <h5 className="m-0 text-2xl font-bold text-gray-700">{displayLabel}</h5>
        {actions}
      </div>
      <PatientNavigationButtons
        id={patientId}
        tenant={tenant ?? ''}
        navigate={navigate}
        activeKey={activeKey}
        treatmentFlowContext={resolvedTreatmentFlowContext}
        pdfTemplateMenu={pdfTemplateMenu}
        disabled={disabled}
      />
    </div>
  );
};

export default PatientPageHeader;
